<template>
	<v-modal :is-open="isOpen" class="bg-white" @close="$emit('close')">
		<v-modal-header class="bg-white" sticky @close="$emit('close')">
			{{ t("filter-title") }}
		</v-modal-header>

		<div class="space-y-md px-10 pb-20">
			<v-category-filter-facet
				v-for="facet in facets"
				:key="facet.id"
				v-model="selectedFacets[facet.id]"
				:facet="facet"
			/>
		</div>

		<template #footer>
			<div
				class="flex-y items-center border-t border-gray-100 bg-white px-10 py-4"
			>
				<v-button
					class="lg:hidden"
					theme="black"
					size="md"
					@click="$emit('close')"
				>
					{{ t("show-x-products", {results}) }}
				</v-button>

				<div class="hidden text-gray-800 lg:block">
					{{ t("filter-info", {results}) }}
				</div>
			</div>
		</template>
	</v-modal>
</template>

<script lang="ts" setup>
import type {Facet} from "@apptus/esales-api";

defineProps<{
	isOpen: boolean;
	results?: number;
}>();

defineEmits<{
	(event: "close"): void;
}>();

const {t} = useI18n();

const facets = inject<Ref<Facet[]>>("facets", ref([]));
const selectedFacets = inject<
	Ref<Record<string, (string | number | boolean)[]>>
>("activeFilters", ref({}));
</script>

<i18n lang="json">
{
	"et": {
		"filter-title": "Filtrid",
		"filter-info": "Sinu otsingule leiti {results} tulemust",
		"show-x-products": "Näita {result} toodet"
	},
	"fi": {
		"filter-title": "Suodattimet",
		"filter-info": "Haullesi löytyi {results} tulosta",
		"show-x-products": "Näytä {results} tuotetta"
	}
}
</i18n>
